import { FoodCleaning } from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

import { withFoodControlPointInstance } from "./foodControlPointService";

/*
Floor Cleaning
Hood Cleaning
Washing Machine Cleaning
*/
export const addFoodCleaning = withFoodControlPointInstance<FoodCleaning>();

export const updateFoodCleaning =
  withFoodControlPointInstance<FoodCleaning>(true);

export async function getFoodCleaningControlByInstanceId(id: string) {
  return axios
    .get("/FoodCleanings/getfoodcleaningbyinstanceid", {
      params: { id },
    })
    .then(
      (res) =>
        ({
          ...res.data,
          controlPointInstanceId: res.data.foodControlPointInstanceId,
        }) as FoodCleaning,
    );
}
